<template>
  <span>{{getPercentageFormatter(params)}}</span>
</template>
<script lang="ts">
import { getPercentageFormatter } from '@/stores/definitions';
import type { PropType } from 'vue';
export default {
  props: {
    params: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({}),
    }
  },
  methods: {
    getPercentageFormatter,
  },
};
</script>
